import React, { useState, useContext } from "react";
import { toast } from "react-toastify";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import DeleteMessageModal from "../DeleteMessageModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);
  const { getSetting } = useContext(SettingsContext);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleDeleteConfirm = async (forEveryone) => {
    setDeleteModalOpen(false);
    try {
      await api.delete(`/messages/${message.id}`, { data: { forEveryone } });
    } catch (err) {
      // Backend signals revoke failed but local delete succeeded
      if (err?.response?.data?.error === "ERR_DELETE_REVOKE_FAILED_FALLBACK_LOCAL") {
        toast.info(i18n.t("deleteMessageModal.revokeFallbackToast"));
        return;
      }
      toastError(err);
    }
  };

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenDeleteModal = () => {
    setDeleteModalOpen(true);
    handleClose();
  };

  const canDelete = user.profile === "admin" || getSetting("userCanDeleteMessage") === "enabled";

  return (
    <>
      <DeleteMessageModal
        open={deleteModalOpen}
        message={message}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
      />
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {canDelete && (
          <MenuItem onClick={handleOpenDeleteModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
